/**
 * Report kinds shared by the Worker handler, the MCP tool and the builder
 * dialog (MCP-5). Dependency-free so the browser never imports a Worker
 * handler to learn the vocabulary (same rule as mcp-scopes.js API_KEY_LIMITS).
 */

export const REPORT_KINDS = Object.freeze([
  'broken-layout',
  'broken-js',
  'missing-asset',
  'wrong-category',
  'other'
]);

export const REPORT_KIND_LABELS = Object.freeze({
  'broken-layout': 'Layout is broken',
  'broken-js': 'JavaScript does not work',
  'missing-asset': 'An image or asset is missing',
  'wrong-category': 'Filed under the wrong category',
  other: 'Something else'
});

export const MAX_REPORT_MESSAGE = 2000;
